import * as React from 'react';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Select } from '../Select/Select';
import MenuItem from '@mui/material/MenuItem';
import { concatPassengerNames } from '../../../../utils';
import { useTheme } from '../../../../theme';
import { isBefore, parse, parseISO, isEqual } from 'date-fns';
export const LinkedTraveller = props => {
    var _a;
    const { t } = useTranslation('Passenger');
    const { LinkedTraveller: theme, Select: selectTheme } = useTheme('Passenger');
    const formState = useFormState();
    const minDateAsStr = props.validations[0].minDate;
    const minDate = minDateAsStr ? parseISO(minDateAsStr) : null;
    const options = props.validations[0].options
        .filter(opt => {
        const passenger = formState.values.passengers[opt.value];
        if (!(passenger === null || passenger === void 0 ? void 0 : passenger.birthDate) || !minDate) {
            return true;
        }
        const passengerBirthday = parse(passenger.birthDate, 'dd.MM.yyyy', new Date());
        return isBefore(passengerBirthday, minDate) || isEqual(passengerBirthday, minDate);
    })
        .map(option => {
        return {
            key: option.label,
            value: option.value
        };
    });
    const valueRenderer = React.useCallback(value => {
        var _a, _b;
        const passenger = formState.values.passengers[value];
        let name = `${t('Adult')} ${parseInt(value, 10) + 1}`;
        if (((_a = passenger === null || passenger === void 0 ? void 0 : passenger.firstName) === null || _a === void 0 ? void 0 : _a.trim()) && ((_b = passenger === null || passenger === void 0 ? void 0 : passenger.lastName) === null || _b === void 0 ? void 0 : _b.trim())) {
            name = concatPassengerNames({
                lastName: passenger.lastName,
                firstName: passenger.firstName,
                middleName: passenger.middleName
            });
        }
        return name;
    }, [props.value, formState.values.passengers]);
    return (React.createElement(Select, Object.assign({}, props, { classes: Object.assign(Object.assign({}, props.classes), { input_error: cn(theme.inputError, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.input_error) }), renderValue: valueRenderer, renderOption: option => {
            return (React.createElement(MenuItem, { key: option.key, value: option.key, className: selectTheme.option }, valueRenderer(option.value)));
        }, readonly: options.length === 1 && props.value === options[0].value, value: props.value, options: options, name: props.name, label: props.label, className: props.className, onChange: props.onChange, onBlur: props.onBlur, error: props.error, disabled: props.disabled, selectFirstOptionByDefault: true })));
};
